import React, { type PropsWithChildren } from 'react';

import { IntlProvider, useIntl } from 'react-intl';

import { getMessagesForLocale } from '../../util/get-messages-for-locale';

const EMPTY: Record<string, string> = {};

const useI18n = (locale: string): Record<string, string> => {
	const [messages, setMessages] = React.useState<Record<string, string>>(EMPTY);

	React.useEffect(() => {
		let aborted = false;
		setMessages(EMPTY);
		getMessagesForLocale(locale)
			.then((messages) => {
				if (!aborted) {
					setMessages(messages);
				}
			})
			.catch((error) => {
				// eslint-disable-next-line no-console
				console.error(error);
			});

		return () => {
			aborted = true;
		};
	}, [locale]);

	return messages;
};

const MessagesIntlProvider = (props: PropsWithChildren<{}>): React.JSX.Element => {
	const { children } = props;
	const intl = useIntl();
	const messages = useI18n(intl.locale);

	return (
		<IntlProvider {...intl} messages={messages}>
			{children}
		</IntlProvider>
	);
};

export default MessagesIntlProvider;
